import PropTypes from "prop-types";

// store
import useBrainStore from "@/store/_brainEmStore";
import useLinkStore from "@/store/_linkStore";

// styles
import "./Summary.css";

// components
import SectionHeading from "@/components/SectionHeading/SectionHeading";
import SummaryBtnGroup from "./SummaryBtnGroup";

// -----------------------------------------------------------------------------

export default function Summary({ isLinkMode }) {
	// Determine which store hook to use
	const useStore = isLinkMode ? useLinkStore : useBrainStore;

	// Subscribe to computed values so that changes in yearsToCompletion or investment trigger a re-render
	const timeToEmulation = useStore((state) => state.yearsToCompletion + 1);
	const totalCost = useStore((state) =>
		(1.2 - state.investment / 1000).toFixed(2),
	);

	// -----------------------------------------------------------------------------

	return (
		<section className="summary">
			<SectionHeading heading="Summary" number={6} />
			{/* Time to Emulation */}
			<div>
				<div className="summary-subheading">
					<svg
						aria-hidden="true"
						xmlns="http://www.w3.org/2000/svg"
						width={24}
						height={24}
						viewBox="0 0 24 24"
					>
						<path
							fill="currentColor"
							d="M6.382 5.968A8.96 8.96 0 0 1 12 4c2.125 0 4.078.736 5.618 1.968l1.453-1.453l1.414 1.414l-1.453 1.453A9 9 0 1 1 3 13c0-2.125.736-4.078 1.968-5.618L3.515 5.93l1.414-1.414zM13 12V7.495L8 14h3v4.5l5-6.5zM8 1h8v2H8z"
						/>
					</svg>
					<h3>Time to Emulation</h3>
				</div>

				<p className="result">{timeToEmulation} years</p>
			</div>

			{/* ---------------------------------------------------------------------- */}

			{/* Total Cost */}
			<div>
				<div className="summary-subheading">
					<svg
						aria-hidden="true"
						xmlns="http://www.w3.org/2000/svg"
						width={24}
						height={24}
						viewBox="0 0 24 24"
					>
						<path
							fill="currentColor"
							d="M12.005 22.003c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10m-3.5-8v2h2.5v2h2v-2h1a2.5 2.5 0 1 0 0-5h-4a.5.5 0 1 1 0-1h5.5v-2h-2.5v-2h-2v2h-1a2.5 2.5 0 1 0 0 5h4a.5.5 0 0 1 0 1z"
						/>
					</svg>
					<h3>Total Cost in USD</h3>
				</div>

				<p className="result">{totalCost} B</p>
			</div>

			{/* ---------------------------------------------------------------------- */}

			{/* Computational Requirements */}
			<div>
				<div className="summary-subheading">
					<svg
						aria-hidden="true"
						xmlns="http://www.w3.org/2000/svg"
						width={24}
						height={24}
						viewBox="0 0 24 24"
					>
						<path
							fill="currentColor"
							d="M5.5 2a1 1 0 0 0-.992.876l-1.5 12A1 1 0 0 0 3 15v6a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-6q0-.062-.008-.124l-1.5-12A1 1 0 0 0 18.5 2zM5 16h14v4H5zm10 1h2v2h-2zm-2 0h-2v2h2z"
						/>
					</svg>
					<h3>Computational Requirements</h3>
				</div>

				<div className="comp-reqs-grid">
					<h4>Operations / second:</h4>
					<p>100 petaFLOP/s</p>
					<h4>Interconnect speed:</h4>
					<p>200 petabits</p>
					<h4>Fast storage:</h4>
					<p>300 petabytes</p>
				</div>
			</div>
			<SummaryBtnGroup isLinkMode={isLinkMode} />
		</section>
	);
}

// -----------------------------------------------------------------------------

Summary.propTypes = {
	isLinkMode: PropTypes.bool.isRequired,
};
